(ns shared.core.components.collapsible-panel
  (:require [shared.core.components.interactive :as interactive]
            [shared.core.components.icon :as icon]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.components.tooltip :as tooltip]
            [shared.core.components.theme :as theme]))

(defn collapsible-panel [{:keys [collapsed? default-collapsed?]}]
  (let [moused-out?* (re/ratom collapsed?)
        collapsed?* (re/ratom default-collapsed?)
        dark?- (re/subscribe [:core/theme-dark?-])]
    (fn [{:keys [collapse-direction collapsed? on-toggle container-style header header-container-style
                 header-style collapsed-container-style content-style transition-time]
          :or {collapse-direction :left
               transition-time "0.3s"}}
         & contents]
      (let [collapsed? (if (nil? collapsed?) @collapsed?* collapsed?)
            horizontal? (contains? #{:left :right} collapse-direction)
            collapse-direction (if collapsed?
                                 (condp = collapse-direction
                                   :top :bottom
                                   :right :left
                                   :bottom :top
                                   :left :right)
                                 collapse-direction)
            gray-border (str "1px solid " (if @dark?-
                                            (style/dark-color :surface :lighter-1)
                                            (style/color :gray :shade-7)))
            on-toggle (or on-toggle #(reset! collapsed?* (not collapsed?)))]
        [theme/theme interactive/interactive :div
         {:style (merge {:display :flex
                         :flex-direction :column
                         :transition transition-time}
                        (if horizontal?
                          {:height "100%"
                           :width :auto}
                          {:height :auto
                           :width "100%"})
                        container-style
                        (when collapsed?
                          (merge {:background-color (style/color :gray :shade-7)
                                  :cursor :pointer
                                  :position :relative}
                                 (if horizontal?
                                   {:flex "0 0 25px"
                                    :width 25}
                                   {:flex "0 0 40px"
                                    :height 40})
                                 collapsed-container-style)))
          :theme (style/dark-style (when collapsed?
                                     {:background-color (style/dark-color :surface :lighter-1)}))
          :on-mouse-out (when collapsed? #(reset! moused-out?* true))
          :hover-style (when collapsed?
                         {:opacity 0.7})
          :on-click (when collapsed?
                      on-toggle)}
         (when (and collapsed? @moused-out?* horizontal?)
           [tooltip/tooltip {:placement (condp = collapse-direction
                                          :top :bottom
                                          :right :left
                                          :bottom :top
                                          :left :right)
                             :tooltip-content header
                             :style {:position :absolute
                                     :top 0
                                     :left 0
                                     :height "100%"
                                     :width "100%"}
                             :target-content [:div {:style {:position :absolute
                                                            :top 0
                                                            :left 0
                                                            :height "100%"
                                                            :width "100%"
                                                            :z-index (style/z :low)}}]}])
         [theme/theme
          :div {:style (cond-> (merge {:background-color (style/color :gray :shade-7)
                                       :flex "0 0 40px"
                                       :display :flex
                                       :align-items :center
                                       :opacity 1
                                       :padding "0 5px 0 10px"
                                       :transition "0.1s"}
                                      header-container-style)
                               (and collapsed? horizontal?) (assoc :opacity 0))
                :theme (style/dark-style {:background-color (style/dark-color :surface :lighter-1)})}
          (into [theme/theme
                 :span {:style (merge {:color (style/color :gray :base)
                                       :font-size 15
                                       :font-weight style/font-extra-bold-weight
                                       :letter-spacing "0.8px"
                                       :text-transform :uppercase
                                       :flex 1
                                       :margin-right 10}
                                      header-style)
                        :theme (style/dark-style {:color (style/dark-color :on-surface :base)})}]
                [header])
          (when on-toggle
            [theme/theme interactive/interactive :div
             {:style {:color (style/color :gray :base)
                      :background-color :transparent
                      :cursor :pointer
                      :display :flex
                      :align-items :center
                      :justify-content :center
                      :transition "0.2s"
                      :height 30
                      :width 30}
              :hover-style {:background-color (style/color :white :base)}
              :theme (style/dark-prop {:style {:color (style/dark-color :on-surface :base)}
                                       :hover-style {:background-color (style/dark-color :on-surface :base)
                                                     :color (style/dark-color :surface :lighter-1)}})
              :on-click #(when-not collapsed?
                           (reset! moused-out?* false)
                           (on-toggle %))}
             [theme/theme
              icon/material-icon {:icon-type (if (= collapse-direction :left)
                                               :chevron-left
                                               :chevron-right)
                                  :style (when-not horizontal?
                                           {:transform (if (= collapse-direction :top)
                                                         "rotate(90deg)"
                                                         "rotate(-90deg)")})
                                  :theme (style/dark-style {:color :inherit})}]])]
         (when (and collapsed? horizontal?)
           [:div
            (when on-toggle
              [theme/theme
               icon/material-icon {:icon-type (if (= collapse-direction :left)
                                                :chevron-left
                                                :chevron-right)
                                   :style {:position :absolute
                                           :top "50%"
                                           :left "50%"
                                           :transform "translate(-50%, -50%)"}
                                   :theme (style/dark-style {:color (style/dark-color :on-surface :base)})}])])
         (into [theme/theme
                :div {:style (cond-> (merge {:background-color (style/color :white :base)
                                             :flex 1
                                             :overflow :auto
                                             :opacity 1
                                             :padding 10
                                             :transition transition-time}
                                            content-style)
                                     (= collapse-direction :top) (assoc :border-bottom gray-border)
                                     (= collapse-direction :right) (assoc :border-left gray-border)
                                     (= collapse-direction :bottom) (assoc :border-top gray-border)
                                     (= collapse-direction :left) (assoc :border-right gray-border)
                                     collapsed? (assoc :opacity 0
                                                       :overflow :hidden))
                      :theme (style/dark-style {:background-color (style/dark-color :background :base)})}]
               contents)]))))
